import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import { TEXT_LIGHT } from '../../utils/constants';
import useThemeQuery from '../../graphql/queries/toggle-theme';

const useStyles = makeStyles(theme => ({
    root: {
        marginTop: theme.spacing(3)
    },
    textLight: {
        color: TEXT_LIGHT,
    },
    textDark: {
        color: '#959FB8',
        fontWeight: 700
    },
    lightActive: {
        color: '#fff',
    },
    darkActive: {
        color: '#0F2234',
        fontWeight: 700
    },
    icon: {
        fontSize: 14,
        marginLeft: theme.spacing(1)
    }
}));

const Head = ({ text, sort, active, width }) => {
    const classes = useStyles();
    const { data } = useThemeQuery();

    return (
        <Box display="flex" alignItems="center" width={width} pl={8}>
            <Typography className={active ? data && data.theme ? classes.lightActive: classes.darkActive : data && data.theme ? classes.textLight: classes.textDark}>
                {text}
            </Typography>
            {sort && <ArrowUpwardIcon className={clsx(data && data.theme ? classes.lightActive: classes.lightDark, classes.icon)} />}
        </Box>
    )
}

export default Head;
